export default __webpack_public_path__ + "static/2-3f74814d3ce36c33b21012c061532e07.jpg";